import { RefundPaymentCell } from './RefundPaymentCell';
import { ViewOnTilledCell } from './ViewOnTilledCell';
import type { InvoicePaymentRead } from 'src/common/external/bambi-api/bambiApi';

function ViewPaymentButton({ payment }: { payment: InvoicePaymentRead }) {
  if (payment.is_manual) {
    return null;
  }

  return (
    <ViewOnTilledCell
      type="payments"
      resourceId={payment.external_payment_id!}
    />
  );
}

export function PaymentsActionCell({
  payment,
}: {
  payment: InvoicePaymentRead;
}) {
  const paymentFailed = payment.charge_status === 'failed';
  if (paymentFailed) {
    return <ViewPaymentButton payment={payment} />;
  }
  return (
    <div className="flex flex-row gap-2">
      <RefundPaymentCell payment={payment} />
      <ViewPaymentButton payment={payment} />
    </div>
  );
}
